"use client";

import type {ComponentType} from "react";
import ScriptToolDetails from "@/components/scripts/presentation/ScriptDetails";
import ToolPresentationDetails, {type ToolDetailsProps} from "./ToolPresentationDetails";

const toolRenderers: ReadonlyMap<string, ComponentType<ToolDetailsProps>> = new Map([
   ["phone_scripts_create", ScriptToolDetails],
]);

/** Routes tool content independently of approval state and decision controls. */
export default function ToolDetails(props: ToolDetailsProps) {
   const Renderer = toolRenderers.get(props.presentation.toolName) ?? ToolPresentationDetails;
   return <Renderer {...props} />;
}
